import { render } from "./EbaySteps.vue?vue&type=template&id=10708fbc&scoped=true"
import script from "./EbaySteps.vue?vue&type=script&lang=js"
export * from "./EbaySteps.vue?vue&type=script&lang=js"

import "./EbaySteps.vue?vue&type=style&index=0&id=10708fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10708fbc"]])

export default __exports__